var React = require('react');

function CommentInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 11l-6 4v-4H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3z","fill":"currentColor","fillRule":"evenodd"}));
}

CommentInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = CommentInline;

CommentInline.default = CommentInline;
